import { FlexBox } from "@brg/ui";
import { LayoutConst } from "core/modules";
import { FC } from "react";
import styled from "styled-components";


export const BackButton = styled(FlexBox)<{ isMediiia?: boolean }>`
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.3px;
  color: #909090;
  cursor: pointer;
  align-items: center;

  &:hover {
    color: ${({theme}) => theme.sendProjectsModal.title};
    svg path {
      fill: ${({theme}) => theme.sendProjectsModal.title};
    }
  }
 
  @media (max-width: ${LayoutConst.screen.md}px) {
    margin-left: 16px;
    margin-top: 16px;
  }
`;

const NavigateBackButton:FC<{text: string, hasOffset?: boolean, backPath: () => void}> = ({text, hasOffset, backPath}) => {
  
  return (
    <BackButton offsetBottom={hasOffset ? 16 : 0} gx={4} onClick={backPath}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
      >
        <path
          d="M4.38149 6L8.8324 1.89987C9.05587 1.69401 9.05587 1.36025 8.83239 1.15439C8.60892 0.948535 8.2466 0.948537 8.02313 1.1544L3.1676 5.62726C2.94413 5.83312 2.94413 6.16688 3.1676 6.37274L8.02313 10.8456C8.2466 11.0515 8.60892 11.0515 8.83239 10.8456C9.05587 10.6398 9.05587 10.306 8.8324 10.1001L4.38149 6Z"
          fill="#909090"
        />
      </svg>
      <span>{text}</span>
    </BackButton>
  );
};
export default NavigateBackButtonimport { FlexBox } from "@brg/ui";
import { LayoutConst } from "core/modules";
import { FC } from "react";
import styled from "styled-components";


export const BackButton = styled(FlexBox)<{ isMediiia?: boolean }>`
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.3px;
  color: #909090;
  cursor: pointer;
  align-items: center;

  &:hover {
    color: ${({theme}) => theme.sendProjectsModal.title};
    svg path {
      fill: ${({theme}) => theme.sendProjectsModal.title};
    }
  }
 
  @media (max-width: ${LayoutConst.screen.md}px) {
    margin-left: 16px;
    margin-top: 16px;
  }
`;

const NavigateBackButton:FC<{text: string, hasOffset?: boolean, backPath: () => void}> = ({text, hasOffset, backPath}) => {
  
  return (
    <BackButton offsetBottom={hasOffset ? 16 : 0} gx={4} onClick={backPath}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
      >
        <path
          d="M4.38149 6L8.8324 1.89987C9.05587 1.69401 9.05587 1.36025 8.83239 1.15439C8.60892 0.948535 8.2466 0.948537 8.02313 1.1544L3.1676 5.62726C2.94413 5.83312 2.94413 6.16688 3.1676 6.37274L8.02313 10.8456C8.2466 11.0515 8.60892 11.0515 8.83239 10.8456C9.05587 10.6398 9.05587 10.306 8.8324 10.1001L4.38149 6Z"
          fill="#909090"
        />
      </svg>
      <span>{text}</span>
    </BackButton>
  );
};
export default NavigateBackButton